module.exports = __webpack_public_path__ + "img/rouge-3.2e657a95.png";